import React, { useEffect, useState } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase'; // Import your Firebase db instance
import ActualiteCard from '../components/ActualiteCard'; // Import the ActualiteCard component
import Navbar from '../components/home/Navbar';
import './styles/ViewActualites.css';

const ViewActualites = () => {
  const [actualites, setActualites] = useState([]);
  const [loading, setLoading] = useState(true); // State to track loading status

  useEffect(() => {
    const fetchActualites = async () => {
      setLoading(true); // Set loading to true before fetching data
      try {
        const q = query(collection(db, 'actualites'), orderBy('timestamp', 'desc'));
        const querySnapshot = await getDocs(q);
        const actualitesList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setActualites(actualitesList);
      } catch (error) {
        console.error('Erreur lors de la récupération des actualités: ', error);
      } finally {
        setLoading(false); // Set loading to false after fetching data
      }
    };

    fetchActualites();
  }, []);

  return (
    <div className="view-actualites">
      <Navbar />
      <div className="title-container">
        <h1 className="actualites-title">Les Actualités</h1>
      </div>
      <div className="actualites-content">
        {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Chargement des actualités...</p>
          </div>
        ) : (
          <div className="actualites-list">
            {actualites.length > 0 ? (
              actualites.map(actualite => (
                <ActualiteCard
                  key={actualite.id}
                  title={actualite.title}
                  description={actualite.description}
                  photo={actualite.photo}
                  date={actualite.timestamp.toDate().toLocaleDateString()}
                />
              ))
            ) : (
              <p className="no-actualites">Aucune actualité disponible pour le moment.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewActualites;
